import { render, staticRenderFns } from "./InterpretationCell.vue?vue&type=template&id=cc154b8a"
import script from "./InterpretationCell.vue?vue&type=script&lang=js"
export * from "./InterpretationCell.vue?vue&type=script&lang=js"
import style0 from "./InterpretationCell.vue?vue&type=style&index=0&id=cc154b8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports